var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumableProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.22,
    height: 73.95,
    viewBox: "0 0 44.22 73.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consumable_Products",
    "data-name": "Consumable Products",
    transform: "translate(-84.706 7.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16159",
    "data-name": "Path 16159",
    d: "M187.48,51.1,191.9,7.616h1.965l5.405,43.733h-3.194l-3.191-7.373-2.948,7.371Z",
    transform: "translate(-89.511 -6.631)",
    fill: "#98baff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11806",
    "data-name": "Group 11806",
    transform: "translate(100.426 0.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16160",
    "data-name": "Path 16160",
    d: "M206.514,26.777l2.457-.245,2.7-9.09-1.228-9.828h-1.965Z",
    transform: "translate(-206.514 -7.613)",
    fill: "#4c36e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16161",
    "data-name": "Path 16161",
    d: "M233.16,276.292l.492-2.213h3.685l1.228,9.336-2.7-.246Z",
    transform: "translate(-229.72 -239.685)",
    fill: "#4c36e4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2735",
    "data-name": "Rectangle 2735",
    width: 1.965,
    height: 1.965,
    transform: "translate(102.637 28.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11807",
    "data-name": "Group 11807",
    transform: "translate(89.615 2.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16163",
    "data-name": "Path 16163",
    d: "M274.855,40.656H257.9V38.688h16.953a2.948,2.948,0,0,0,0-5.9h-7.368a4.422,4.422,0,0,1,0-8.845h1.72a1.474,1.474,0,1,0,0-2.948H259l1.966-1.965H269.2a3.44,3.44,0,0,1,0,6.88h-1.719a2.457,2.457,0,1,0,0,4.914h7.371a4.914,4.914,0,1,1,0,9.828Z",
    transform: "translate(-240.459 -19.033)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16164",
    "data-name": "Path 16164",
    d: "M128.664,182.111h-2.457a3.443,3.443,0,0,1-3.44-3.44v-.249a3.2,3.2,0,0,1,3.194-3.194.983.983,0,0,0,.983-.983,2.952,2.952,0,0,1,2.948-2.948h3.44v1.965h-3.439a.983.983,0,0,0-.983.983,2.952,2.952,0,0,1-2.948,2.948,1.23,1.23,0,0,0-1.228,1.228v.246a1.476,1.476,0,0,0,1.474,1.474h2.457v1.965Z",
    transform: "translate(-122.767 -151.646)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17128",
    "data-name": "Path 17128",
    d: "M.194,0C2.539,12.325,12.468,10.9,12.468,10.9a31.06,31.06,0,0,0,4.794-.084,9.659,9.659,0,0,1-4.783,1.954C5.311,14.464-1.217,7.642.194,0",
    transform: "matrix(0.921, -0.391, 0.391, 0.921, 90.437, -1.112)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16165",
    "data-name": "Path 16165",
    d: "M116.887,53.314a6.382,6.382,0,0,0-5.11,2.558L105.231,0H101.5L95.925,55.536a6.384,6.384,0,1,0,1.508,4.906h3.658V58.474H97.606L98.889,45.7h2.2l2.406-6.016L105.9,45.7h2.7l1.5,12.776h-3.662v1.967h4.1a6.387,6.387,0,1,0,6.344-7.123ZM91.092,64.125A4.422,4.422,0,1,1,95.514,59.7a4.422,4.422,0,0,1-4.422,4.422ZM103.28,1.965h.2l1.048,8.944-2.4,8.079-.564.056Zm-3.52,41.77h-.674l2.282-22.692,2.272-.228,1.473-4.956,2.114,18.049h-3.533Zm7.473,0-2.678-6.695.467-1.167h2.433l.921,7.862Zm9.654,20.39a4.422,4.422,0,1,1,4.422-4.422,4.422,4.422,0,0,1-4.422,4.422Z",
    fill: "#5035ed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumableProducts);
export default __webpack_public_path__ + "static/media/ConsumableProducts.0f9201a0a1208840e737ffe132c51e20.svg";
export { ForwardRef as ReactComponent };